<form [formGroup]="form">
  <div class="row">
    <div class="col-md-6">
      <mat-form-field class="mat-block">
        <mat-label><span [innerHtml]="'Base Charge (' + currencySymbol + '):'"></span></mat-label>
        <input matInput type="number" min="0" formControlName="charge" />
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <mat-form-field class="mat-block">
        <mat-label><span [innerHtml]="'Additional Guests Fee (' + currencySymbol + '):'"></span></mat-label>
        <input matInput type="number" min="0" formControlName="extraGuests" />
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <h6>Discounts &amp; Fees</h6>
    </div>
  </div>

  <div formArrayName="discounts" *ngFor="let item of discounts.controls; let i = index" class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-9 discount-controls">
          <button (click)="removeDiscountsOrFees(i)" class="remove-discount discount-btn" type="button">
            <i class="fal fa-minus"></i>
          </button>
          <span class="discount-msg" *ngIf="item.value.amount > 0">Added to the base charge:</span>
          <span class="discount-msg" *ngIf="item.value.amount < 0">Subtracted from the base charge:</span>
          <span class="discount-msg" *ngIf="!item.value.amount">Discount or fee:</span>
        </div>
        <div [formGroupName]="i" class="col-md-3 discount-holder">
          <mat-form-field class="mat-block">
            <mat-label><span [innerHtml]="'Amount (' + currencySymbol + '):'"></span></mat-label>
            <input type="number" formControlName="amount" matInput />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div class="row mb-3" *ngIf="discounts.length < discountsOrFeesLimit">
    <div class="col-md-9 discount-controls">
      <button (click)="addDiscountsOrFees()" class="add-discount discount-btn" type="button">
        <i class="fal fa-plus"></i>
      </button>
      <a (click)="addDiscountsOrFees()" href="javascript:;"> Add Discount/Fee </a>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <h6>Taxes</h6>
    </div>
    <div class="col-md-6">
      <mat-form-field class="mat-block">
        <mat-label><span [innerHtml]="'Tax (%):'"></span></mat-label>
        <input matInput type="number" min="0" formControlName="taxPercent" />
      </mat-form-field>
    </div>

    <div class="col-md-6">
      <mat-form-field class="mat-block">
        <mat-label><span [innerHtml]="'Tax (' + currencySymbol + '):'"></span></mat-label>
        <input matInput type="number" min="0" formControlName="taxFlat" />
      </mat-form-field>
    </div>
    <div class="offset-md-8 col-md-4" *ngIf="getTaxTotal() as taxTotal">
      <h6>
        Tax Total:
        <span [innerHtml]="taxTotal | tokeetCurrency: inquiry?.rental?.currency"></span>
      </h6>
    </div>
  </div>
  <div class="row">
    <div class="offset-md-8 col-md-4">
      <h6>
        Total:
        <span [innerHtml]="getTotal() | tokeetCurrency: inquiry?.rental?.currency"></span>
      </h6>
    </div>
  </div>
</form>

<div class="footer-control">
  <button
    [disabled]="loading || calculating"
    (click)="close.emit(true)"
    type="button"
    class="btn btn-outline btn-default-outline text-uppercase"
  >
    <i class="fal fa-times"></i> cancel
  </button>
  <button [disabled]="loading || calculating" (click)="reset()" type="button" class="btn btn-cst-info text-uppercase">
    <i class="fal fa-sync-alt"></i> reset
  </button>
  <button
    *ngIf="!loading && !calculating"
    (click)="save(form)"
    type="button"
    class="btn btn-success text-uppercase create-btn"
  >
    <i class="fal fa-save"></i> save
  </button>
  <button
    *ngIf="loading || calculating"
    matTooltip="Calculating cost..."
    matTooltipPosition="above"
    matTooltipClass="text-center"
    type="button"
    class="btn btn-success text-uppercase create-btn"
  >
    <i class="fal fa-save"></i> save
  </button>
</div>
